var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronSmallRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.71,16.71l-1.41-1.41,3.29-3.29-3.29-3.29,1.41-1.41,4,4v1.41l-4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronSmallRight);
export default __webpack_public_path__ + "static/1788088179/media/icon-chevron-small-right.75e5bf2fb3f10679a3e36c6259bba1cc.svg";
export { ForwardRef as ReactComponent };